'use client';

import React, { useState } from 'react';
import { ExternalLink, BookOpen } from 'lucide-react';

interface CiteProps {
  number: string;
  doi?: string;
  title: string;
  author: string;
  journal: string;
  year: string;
  url?: string;
}

export default function Cite({ number, doi, title, author, journal, year, url }: CiteProps) {
  const [isOpen, setIsOpen] = useState(false);

  const citeUrl = url || (doi ? `https://doi.org/${doi}` : undefined);

  return (
    <span 
      className='relative inline-block mx-0.5 group'
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <sup className='text-[10px] font-black text-brand-dark dark:text-brand-dark-text-primary bg-brand-dark/10 dark:bg-brand-dark-text-primary/10 px-1 py-0.5 rounded cursor-help transition-all hover:bg-brand-dark hover:text-white dark:hover:bg-brand-dark-text-primary dark:hover:text-black font-mono'>
        [{number}]
      </sup>

      {isOpen && (
        <span className='absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-72 bg-card border border-border/80 p-4 rounded-xl shadow-2xl z-50 text-left flex flex-col space-y-2 pointer-events-auto'>
          <span className='text-[10px] font-black uppercase text-muted-foreground tracking-widest flex items-center gap-1.5'>
            <BookOpen className='size-3.5' /> Scientific Citation
          </span>
          <span className='text-foreground text-xs font-bold leading-snug'>
            {title}
          </span>
          <span className='text-muted-foreground text-[11px] leading-normal font-medium'>
            {author} — *{journal}*, {year}
          </span>
          {citeUrl && (
            <a
              href={citeUrl}
              target='_blank'
              rel='noopener noreferrer'
              className='text-[11px] text-[#066653] font-black inline-flex items-center gap-1 hover:underline pt-1 border-t border-border/40'
            >
              View Publication <ExternalLink className='size-3' />
            </a>
          )}
        </span>
      )}
    </span>
  );
}
